import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-bf",
  "use": "icon-icon-bf-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-bf\">\n  <g fill-rule=\"evenodd\">\n    <path fill=\"#de0000\" d=\"M512 511.6H.5V0H512z\" />\n    <path fill=\"#35a100\" d=\"M511.8 512H0V256.2h511.7z\" />\n  </g>\n  <path fill=\"#fff300\" fill-rule=\"evenodd\" d=\"m389 223.8-82.9 56.5 31.7 91.6-82.7-56.7-82.8 56.7 31.7-91.6-82.8-56.6 102.3.2 31.6-91.7 31.5 91.6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol